<script>
import MenuLink from './MenuLink.vue';

export default {
  components: {
    MenuLink,
  },
  props: {
    module: Object,
  },
};
</script>
<template>
  <v-list>
    <template v-for="item in module.items">
      <MenuLink
        v-if="item.type==='link'"
        :key="item.key"
        :value="item.value"
        :label="item.label"
        :href="item.href"
        :to="item.to"
        :icon="item.icon"
      />
      <v-list-group
        v-if="item.type==='group' && !module.min"
        :key="item.key"
        :value="item.value"
        :prepend-icon="item.icon"
        :title="item.label"
        color
      >
        <template v-slot:activator>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </template>
        <MenuLink
          v-for="link in item.links"
          :key="link.key"
          :value="link.value"
          :label="link.label"
          :href="link.href"
          :to="link.to"
        />
      </v-list-group>
      <template
        v-if="item.type==='group' && module.min"
      >
        <MenuLink
          v-for="link in item.links"
          :key="link.key"
          :value="link.value"
          :label="link.label"
          :href="link.href"
          :to="link.to"
          :icon="link.icon"
        />
      </template>
    </template>
  </v-list>
</template>
